import { modalWrapperOptions } from '@psl/components/modal/FlexModalWrapper/FlexModalWrapper';
import { wrapNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';

const ReclaimReferralPageContent = lazy(
  () => import('./ReclaimReferralPageContent'),
);

export const ReclaimReferralPage = wrapNavigatorScreen(
  ReclaimReferralPageContent,
  modalWrapperOptions(),
);
